import * as React from 'react';
import { cn } from '../../lib/utils';

const colBase: Record<number, string> = {
  1: 'w-1/12', 2: 'w-2/12', 3: 'w-3/12', 4: 'w-4/12', 5: 'w-5/12', 6: 'w-6/12',
  7: 'w-7/12', 8: 'w-8/12', 9: 'w-9/12', 10: 'w-10/12', 11: 'w-11/12', 12: 'w-full',
};
const colMd: Record<number, string> = {
  1: 'md:w-1/12', 2: 'md:w-2/12', 3: 'md:w-3/12', 4: 'md:w-4/12', 5: 'md:w-5/12', 6: 'md:w-6/12',
  7: 'md:w-7/12', 8: 'md:w-8/12', 9: 'md:w-9/12', 10: 'md:w-10/12', 11: 'md:w-11/12', 12: 'md:w-full',
};
const colLg: Record<number, string> = {
  1: 'lg:w-1/12', 2: 'lg:w-2/12', 3: 'lg:w-3/12', 4: 'lg:w-4/12', 5: 'lg:w-5/12', 6: 'lg:w-6/12',
  7: 'lg:w-7/12', 8: 'lg:w-8/12', 9: 'lg:w-9/12', 10: 'lg:w-10/12', 11: 'lg:w-11/12', 12: 'lg:w-full',
};

export function gridWidth(s?: number, m?: number, l?: number): string {
  return cn(s ? colBase[s] : undefined, m ? colMd[m] : undefined, l ? colLg[l] : undefined);
}

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'value'> {
  label?: React.ReactNode;
  error?: string | boolean;
  s?: number;
  m?: number;
  l?: number;
  inputClassName?: string;
  value?: React.InputHTMLAttributes<HTMLInputElement>['value'] | null;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, s, m, l, className, inputClassName, id, disabled, value, ...props }, ref) => {
    const hasError = Boolean(error);
    const errorMessage = typeof error === 'string' ? error : undefined;

    return (
      <div className={cn('px-1', gridWidth(s, m, l), className)}>
        {label && (
          <label htmlFor={id} className="mb-1 block text-sm font-medium text-foreground">
            {label}
          </label>
        )}
        <input
          id={id}
          ref={ref}
          disabled={disabled}
          value={value === null ? '' : value}
          aria-invalid={hasError || undefined}
          className={cn(
            'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors',
            'placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
            'disabled:cursor-not-allowed disabled:opacity-50',
            hasError && 'border-destructive focus-visible:ring-destructive',
            inputClassName
          )}
          {...props}
        />
        {errorMessage && <p className="mt-1 text-xs text-destructive">{errorMessage}</p>}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
